(function ($) {

  /*$(document).ready(function () {
    $('.variations select').on( 'change.select2', function(e) {
      toggleMessage(!$('.single_add_to_cart_button').hasClass('wc-variation-selection-needed'))
    })

    $('form.variations_form').on( 'click.wc-variation-form', '.reset_variations', function(e) {
      toggleMessage(!$('.single_add_to_cart_button').hasClass('wc-variation-selection-needed'))
    })

    function toggleMessage(isSelected) {

      $('form.variations_form')
        .find('.reset_variations')
        .toggleClass('d-none', !isSelected)
      $('form.variations_form')
        .find('.variation-select-needed-notice')
        .toggleClass('d-none', isSelected)

    }
  })*/



})(jQuery)
